import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, X } from 'lucide-react';
export interface TocItem {
  id: string;
  title: string;
  subtitle?: string;
}
interface BookSidebarProps {
  items: TocItem[];
  activeId: string;
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (id: string) => void;
}
export function BookSidebar({
  items,
  activeId,
  isOpen,
  onClose,
  onNavigate
}: BookSidebarProps) {
  return <>
      {/* Mobile overlay */}
      {isOpen && <div className="fixed inset-0 z-40 bg-charcoal/20 backdrop-blur-sm lg:hidden" onClick={onClose} data-id="element-31" />}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 w-80 transform border-r border-sage/20 bg-cream shadow-2xl transition-transform duration-300 ease-in-out lg:translate-x-0 lg:shadow-none ${isOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-32">
        <div className="flex h-full flex-col" data-id="element-33">
          <div className="flex items-center justify-between border-b border-sage/20 p-6" data-id="element-34">
            <div className="flex items-center gap-3 text-forest" data-id="element-35">
              <BookOpen className="h-6 w-6" data-id="element-36" />
              <span className="font-sans font-bold tracking-tight" data-id="element-37">Índice</span>
            </div>
            <button onClick={onClose} className="rounded-full p-2 text-charcoal/50 hover:bg-sage/10 hover:text-charcoal lg:hidden" data-id="element-38">
              <X className="h-5 w-5" data-id="element-39" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-4" data-id="element-40">
            <nav className="space-y-1" data-id="element-41">
              {items.map(item => {
              const isActive = activeId === item.id;
              return <button key={item.id} onClick={() => onNavigate(item.id)} className={`w-full rounded-xl px-4 py-3 text-left transition-all ${isActive ? 'bg-forest text-cream shadow-md' : 'text-charcoal/70 hover:bg-sage/10 hover:text-charcoal'}`} data-id="element-42">
                    <div className={`font-sans text-sm font-medium ${isActive ? 'text-cream' : 'text-forest'}`} data-id="element-43">
                      {item.title}
                    </div>
                    {item.subtitle && <div className={`mt-1 font-serif text-xs ${isActive ? 'text-cream/80' : 'text-charcoal/50'}`} data-id="element-44">
                        {item.subtitle}
                      </div>}
                  </button>;
            })}
            </nav>
          </div>

          <div className="border-t border-sage/20 p-6" data-id="element-45">
            <div className="text-center font-sans text-xs text-charcoal/40" data-id="element-46">
              Protocolo Anti-Inflamatorio 65+
            </div>
          </div>
        </div>
      </div>
    </>;
}